import { AllFieldTypes } from "@cak-legacy/generation-schema-core";
import { Field } from "../interface/SimpleForm/Field";
import { PredefinedRegelingField } from "../interface/SimpleForm/PredefinedRegelingField";
import { nameOf } from "./nameOf";

export function isAllFieldType(field: Field): field is AllFieldTypes {
  return nameOf<AllFieldTypes>().type != undefined && (nameOf<AllFieldTypes>().type || "typescript error fix") in field;
}

export function isRegelingFieldType(field: Field): field is PredefinedRegelingField {
  return nameOf<PredefinedRegelingField>().regelingOptions != undefined && (nameOf<PredefinedRegelingField>().regelingOptions || "typescript error fix") in field;
}